<template>
    <div class="step tw-flex tw-flex-col tw-items-center tw-w-64 tw-mb-[3.1rem]">
        <div class="step-content-wrapper tw-relative tw-mb-4">
            <div
                    class="step-circle tw-w-[4.6rem] tw-h-[4.6rem] tw-font-poppins tw-rounded-full tw-bg-[#0C3C77] tw-text-white tw-flex tw-items-center tw-justify-center tw-font-bold tw-text-4xl"
                    :style="{background: circleColor}"
            >
                {{ circleContent }}
            </div>
            <svg
                    v-if="circleDashedLine"
                    xmlns="http://www.w3.org/2000/svg"
                    class="circle-dashed-line tw-absolute tw-top-1/2 tw-left-full tw-h-[3px] tw-w-[21.8125rem]"
                    viewBox="0 0 349 3"
                    fill="none"
            >
                <path
                        d="M0 1.5H349"
                        stroke="#D5D7DD"
                        stroke-width="3"
                        stroke-dasharray="16 13"
                />
            </svg>
        </div>
        <div class="step-title tw-text-[#161C2D] tw-text-center tw-font-poppins tw-text-xl tw-font-bold tw-leading-8 tw-tracking-[-0.03125rem]">
            {{ title }}
        </div>
        <div class="step-description tw-text-[#161C2D] tw-text-center tw-font-poppins tw-text-lg tw-font-normal tw-opacity-70 tw-leading-normal tw-tracking-[-0.0125rem] tw-mt-2 tw-max-w-[15.8125rem]">
            <span v-html="description" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Step',
    components: {},
    mixins: [],
    props: {
        circleColor: {
            type: String,
            required: true,
        },
        circleContent: {
            type: [String, Number],
            required: true,
        },
        circleDashedLine: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {

    },
    methods: {

    },

};
</script>
